export const isValidEmail = (email: string): boolean => {
    const emailString = String(email);
    return (
        emailString.length > 0 &&
        /^(?!\.)[\w.\$+\-!#%&'`*\/=?^_{}|~]+@[\w-]+(?:\.[\w-]+)+$/.test(emailString)
    );
};

export const isValidPostcode = (postcode: string): boolean => {
    const POSTCODE_REGEX = /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/i;
    return POSTCODE_REGEX.test(postcode.trim());
};

